// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"b7c4a238","213":"dba25587","239":"a2c8af17","453":"8a7a60c6","455":"24d49d61","864":"28256753"}[chunkId] + ".chunk.js";
};